// cspell:words camaro chevelle
import type { MenuProps } from '@pega/cosmos-react-core';

export const countries: MenuProps['items'] = [
  {
    id: '1',
    primary: 'United States of America',
    secondary: ['North America'],
    visual: '🇺🇸',
    items: [
      {
        id: '1-2',
        primary: 'Maine',
        tooltip:
          'Maine, the northeasternmost U.S. state, is known for its rocky coastline, maritime history and nature areas like the granite and spruce islands of Acadia National Park. '
      },
      { id: '1-3', primary: 'Rhode Island' },
      {
        id: '1-1',
        primary: 'Massachusetts',
        items: [
          {
            id: 'group-1-1-b',
            label: 'B',
            items: [
              { id: '1-1-1', primary: 'Barnstable County' },
              { id: '1-1-2', primary: 'Berkshire County' },
              { id: '1-1-3', primary: 'Bristol County' }
            ]
          },
          { id: '1-1-4', primary: 'Dukes County' },
          { id: '1-1-5', primary: 'Essex County' },
          { id: '1-1-6', primary: 'Franklin County' },
          {
            id: '1-1-h',
            label: 'H',
            items: [
              { id: '1-1-7', primary: 'Hampden County' },
              { id: '1-1-8', primary: 'Hampshire County' }
            ]
          },
          { id: '1-1-9', primary: 'Middlesex County' },
          {
            id: '1-1-n',
            label: 'N',
            items: [
              { id: '1-1-10', primary: 'Nantucket County' },
              { id: '1-1-11', primary: 'Norfolk County' }
            ]
          },
          { id: '1-1-12', primary: 'Plymouth County' },
          { id: '1-1-13', primary: 'Suffolk County' },
          { id: '1-1-14', primary: 'Worcester County' }
        ]
      },
      { id: '1-4', primary: 'Washington' },
      { id: '1-5', primary: 'California' },
      { id: '1-6', primary: 'Alabama' },
      { id: '1-7', primary: 'Alaska' },
      { id: '1-8', primary: 'Kentucky' },
      { id: '1-9', primary: 'Ohio' },
      { id: '1-10', primary: 'Minnesota' },
      { id: '1-11', primary: 'Iowa' },
      {
        id: '1-12',
        primary: 'Colorado',
        tooltip:
          'Colorado, a western U.S. state, has a diverse landscape of arid desert, Perched a mile above sea level, Denver, Colorado’s capital and largest city, features a vibrant downtown area'
      }
    ]
  },
  {
    id: '2',
    primary: 'Poland',
    secondary: ['Europe'],
    visual: '🇵🇱',
    items: [
      {
        id: '2-1',
        primary: 'Krakow'
      }
    ]
  },
  { id: '3', primary: 'England', secondary: ['Europe'], visual: '🏴󠁧󠁢󠁥󠁮󠁧󠁿' },
  { id: '4', primary: 'France', secondary: ['Europe'], visual: '🇫🇷' },
  { id: '5', primary: 'Germany', secondary: ['Europe'], visual: '🇩🇪' },
  { id: '6', primary: 'Spain', secondary: ['Europe'], visual: '🇪🇸' },
  { id: '7', primary: 'Italy', secondary: ['Europe'], visual: '🇮🇹' },
  { id: '8', primary: 'Mexico', secondary: ['North America'], visual: '🇲🇽' },
  { id: '9', primary: 'Brasil', secondary: ['South America'], visual: '🇧🇷' },
  { id: '10', primary: 'Austria', secondary: ['Europe'], visual: '🇦🇹' },
  { id: '11', primary: 'Belgium', secondary: ['Europe'], visual: '🇧🇪' },
  { id: '12', primary: 'Chile', secondary: ['South America'], visual: '🇨🇱' },
  { id: '13', primary: 'Hungary', secondary: ['Europe'], visual: '🇭🇺' },
  { id: '14', primary: 'Iceland', secondary: ['Europe'], visual: '🇮🇸' },
  { id: '15', primary: 'Sweden', secondary: ['Europe'], visual: '🇸🇪' },
  { id: '16', primary: 'Norway', secondary: ['Europe'], visual: '🇳🇴' },
  { id: '17', primary: 'Netherlands', secondary: ['Europe'], visual: '🇳🇱' },
  { id: '18', primary: 'Portugal', secondary: ['Europe'], visual: '🇵🇹' },
  { id: '19', primary: 'Canada', secondary: ['North America'], visual: '🇨🇦' },
  { id: '20', primary: 'Czech Republic', secondary: ['Europe'], visual: '🇨🇿' },
  { id: '21', primary: 'Argentina', secondary: ['South America'], visual: '🇦🇷' },
  { id: '22', primary: 'Denmark', secondary: ['Europe'], visual: '🇩🇰' },
  { id: '23', primary: 'Estonia', secondary: ['Europe'], visual: '🇪🇪' },
  { id: '24', primary: 'Finland', secondary: ['Europe'], visual: '🇫🇮' },
  { id: '25', primary: 'Slovenia', secondary: ['Europe'], visual: '🇸🇮' },
  { id: '26', primary: 'Slovakia', secondary: ['Europe'], visual: '🇸🇰' },
  { id: '27', primary: 'Romania', secondary: ['Europe'], visual: '🇷🇴' }
];

export const cars: MenuProps['items'] = [
  {
    id: 'dodge',
    label: 'Dodge',
    items: [
      {
        id: 'dodge charger',
        primary: 'Charger',
        items: [
          {
            id: "dodge charger 1960's",
            primary: "1960's",
            items: [
              {
                id: 'dodge charger 1965',
                primary: '1965'
              },
              {
                id: 'dodge charger 1966',
                primary: '1966'
              },
              {
                id: 'dodge charger 1967',
                primary: '1967'
              },
              {
                id: 'dodge charger 1968',
                primary: '1968'
              },
              {
                id: 'dodge charger 1969',
                primary: '1969'
              }
            ]
          },
          {
            id: "dodge charger 1970's",
            primary: "1970's",
            items: [
              {
                id: 'dodge charger 1970',
                primary: '1970'
              },
              {
                id: 'dodge charger 1971',
                primary: '1971'
              },
              {
                id: 'dodge charger 1972',
                primary: '1972'
              },
              {
                id: 'dodge charger 1973',
                primary: '1973'
              },
              {
                id: 'dodge charger 1974',
                primary: '1974'
              }
            ]
          }
        ]
      },
      {
        id: 'dodge challenger',
        primary: 'Challenger'
      },
      {
        id: 'dodge coronet',
        primary: 'Coronet'
      }
    ]
  },
  {
    id: 'pontiac',
    label: 'Pontiac',
    items: [
      {
        id: 'gto',
        primary: 'GTO'
      },
      {
        id: 'firebird',
        primary: 'Firebird'
      }
    ]
  },
  {
    id: 'ford',
    label: 'Ford',
    items: [
      {
        id: 'mustang',
        primary: 'Mustang'
      },
      {
        id: 'falcon',
        primary: 'Falcon'
      },
      {
        id: 'torino',
        primary: 'Torino'
      }
    ]
  },
  {
    id: 'chevrolet',
    label: 'Chevrolet',
    items: [
      {
        id: 'camaro',
        primary: 'Camaro'
      },
      {
        id: 'chevelle',
        primary: 'Chevelle'
      }
    ]
  },
  {
    id: 'buick gran sport',
    primary: 'Buick Gran Sport'
  },
  {
    id: 'oldsmobile 442',
    primary: 'Oldsmobile 442'
  }
];
